import swal from 'sweetalert'
export default {
  name: 'list',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    surveys () {
      return this.$store.getters['Survey/getSurveys']
    }
  },
  mounted () {
    this.$store.dispatch('Survey/listSurveys')
  },
  methods: {
    showSurvey (survey) {
      this.$router.push('show/' + survey.id)
    },
    destroy (survey) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('Survey/destroySurvey', { survey }).then(res => {
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.fail()
            })
          }
        })
    },
    update (survey) {
      this.$router.push('/survey/' + survey.id + '/edit')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/survey/list/list.js